import { render, staticRenderFns } from "./shops-map.vue?vue&type=template&id=4670d5f3&scoped=true&"
import script from "./shops-map.vue?vue&type=script&lang=js&"
export * from "./shops-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4670d5f3",
  null
  
)

export default component.exports